<div class="component-wrapper referenzen">
  <main>
    <div class="content-wrapper">
      <h1>Lass die anderen sprechen</h1>
      <div *ngFor="let bewertung of bewertungen" class="bewertung" [innerHtml]="bewertung.bewertung"></div>
    </div>
  </main>
</div>
